import { render, staticRenderFns } from "./WeeklyThermalFailRateSummary.vue?vue&type=template&id=492dc242"
import script from "./WeeklyThermalFailRateSummary.vue?vue&type=script&lang=js"
export * from "./WeeklyThermalFailRateSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports